exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qr-image {\n  /*width: 60px;*/\n  height: 60px;\n  /*margin-right: 3px;*/\n  background-color: #FFFFFF;\n  /*border: 1px solid #E6E8EA;*/\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/product/product-setting/point_of_sale.css
// module id = ../../../../../src/app/pages/admin/evs/product/product-setting/point_of_sale.css
// module chunks = 3